<template>
  <el-button>
    <img src="/bundles/wordpress.svg" height="16" />
    <template></template>
  </el-button>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    applicationId: String
  },
  computed: {
    application () {
      return this.applications.find((a) => a.id === this.applicationId)
    },
    ...mapState(['applications'])
  }
}
</script>
